export default function Footer() {
  return (
    <footer className="py-6 text-center bg-gray-50">
      <div className="flex justify-center gap-6 text-xs text-gray-400">
        <a
          href="/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="cursor-pointer"
        >
          Privacy Policy
        </a>
        <a
          href="/terms"
          target="_blank"
          rel="noopener noreferrer"
          className="cursor-pointer"
        >
          Terms of Service
        </a>
      </div>
    </footer>
  );
}
